// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"b2cfea23","445":"a6716dc7","956":"448127d1"}[chunkId] + ".chunk.js";
};